import {inject, Injectable} from '@angular/core';
import {CreateNoteChangePrice, NoteChangePrice, NoteChangePriceDialogData} from "../types/note-change-price.types";
import {ButtonRecordValue, GetSelectDataParams, SelectData} from "../../../../../../../core/types/records-table.types";
import {BaseModalApiService} from "../../../../../../../core/components/modals/services/base-modal-api.service";
import {noteChangePriceModalResourceType} from "../configs/note-change-price-config";
import {RecordTableApiService} from "../../../../../../../core/services-api/record-table-api.service";

@Injectable({
  providedIn: 'root'
})
export class NoteChangePriceService {
  private baseModalApiService: BaseModalApiService = inject(BaseModalApiService);
  private recordTableApiService: RecordTableApiService = inject(RecordTableApiService);

  public getButtonData(noteChangePriceDialogData: NoteChangePriceDialogData): ButtonRecordValue {
    const { parentData, keyModal } = noteChangePriceDialogData;
    return parentData[keyModal] as ButtonRecordValue;
  }

  public createNoteChangePrice(createNoteChangePrice: CreateNoteChangePrice): Promise<NoteChangePrice> {
    return new Promise((resolve, reject) => {
      this.baseModalApiService.createDataInModal<CreateNoteChangePrice, NoteChangePrice>(createNoteChangePrice, `${noteChangePriceModalResourceType.path}/create`).subscribe({
        next: (data) => resolve(data),
        error: (error) => reject(error)
      });
    });
  }

  public async getProductSelectData(getSelectDataParams: GetSelectDataParams): Promise<Array<SelectData>> {
    return new Promise((resolve, reject) => {
      this.recordTableApiService.fetchSelectData(getSelectDataParams).subscribe({
        next: (selectData: Array<SelectData>) => resolve(selectData),
        error: (error) => reject(error)
      });
    });
  }
}
